import React, { type FC } from 'react';
import { BackCrumb } from './SubComponents/BackCrumb';
import css from './TemplatePage.scss';
import { TemplateMainCard } from './SubComponents/TemplateMainCard';
import { Instructions } from './SubComponents/Instructions';
import { RelatedTemplates } from './SubComponents/RelatedTemplates';
import { HowToBuild } from './SubComponents/HowToBuild';
import { StickyHeader } from './SubComponents/StickyHeader';
import { AppLoader } from '../App/AppLoader';
import { DataHooks } from '../../constants/dataHooks';
import { useTemplatesData } from '../../hooks/useTemplatesData';
import { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { useExperiments } from '@wix/fe-essentials/react';
import { BlocksHarmonyNotification } from '../BlocksHarmonyNotification/BlocksHarmonyNotification';

export const TemplatePage: FC = () => {
  const upperPartRef = React.useRef<HTMLDivElement>(null);
  const { currentTemplate: template } = useTemplatesData();
  const { experiments } = useExperiments({ readOnly: true });
  const shouldDisplayNotifications = experiments.enabled(
    'specs.dcc.displayHarmonyNotifications',
  );

  if (!template) {
    return <AppLoader />;
  }

  const isBlocksTemplate = template.developmentTools?.includes(
    DevelopmentTool.BLOCKS,
  );

  return (
    <>
      <div
        data-hook={DataHooks.TemplatePage}
        className={css.templatePageWrapper}
      >
        <StickyHeader upperPartRef={upperPartRef} />
        <div className={css.templatePageLayout}>
          <div className={css.upperPartWrapper} ref={upperPartRef}>
            <BackCrumb />
            {shouldDisplayNotifications && isBlocksTemplate && (
              <div className={css.blocksNotificationWrapper}>
                <BlocksHarmonyNotification />
              </div>
            )}
            <TemplateMainCard />
          </div>
          <Instructions />
          <HowToBuild />
          <RelatedTemplates />
        </div>
      </div>
    </>
  );
};
